import script from "./AddressEdit.vue?vue&type=script&setup=true&lang=js"
export * from "./AddressEdit.vue?vue&type=script&setup=true&lang=js"

import "./AddressEdit.vue?vue&type=style&index=0&id=013a39c7&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-013a39c7"]])

export default __exports__